import React, { useMemo } from "react";
import { useTranslate } from "@refinedev/core";
import { DocumentPositionPoint } from "types/";
import { AnalyticsLineChart, type DatasetConfig } from "./AnalyticsLineChart";
import { analyticsTheme } from "./analyticsTheme";
import { getPercentageAxis, getGridAxis, withClippedTicks } from "./utils/";

const T_PREFIX =
  "media.projects.analytics.documentHighlighter.readingDepthCurve";

export interface ReadingDepthCurveChartProps {
  data: DocumentPositionPoint[] | undefined;
  loading: boolean;
}

export const ReadingDepthCurveChart: React.FC<ReadingDepthCurveChartProps> = ({
  data,
  loading,
}) => {
  const t = useTranslate();
  const chartOptions = useMemo(
    () => ({
      scales: { y: getPercentageAxis(), x: withClippedTicks(getGridAxis()) },
    }),
    []
  );

  const points = data ?? [];

  const labels = useMemo(
    // page_number is 0-indexed from the API; display it 1-based for readers.
    () => points.map((p) => `p.${p.page_number + 1}`),
    [points]
  );

  const datasets = useMemo<DatasetConfig[]>(
    () => [
      {
        label: t(`${T_PREFIX}.readers`),
        data: points.map((p) => Math.round(p.readers_pct * 100) / 100),
        color: analyticsTheme.datasetBlue,
      },
    ],
    [points, t]
  );

  return (
    <AnalyticsLineChart
      title={t(`${T_PREFIX}.title`)}
      subtitle={t(`${T_PREFIX}.subtitle`)}
      labels={labels}
      datasets={datasets}
      loading={loading}
      height={200}
      chartOptions={chartOptions}
    />
  );
};
